// This plugin initializes loyalty state from cookie
// It runs before shopifyRequest plugin (both start with 0.)
export default defineNuxtPlugin(() => {
  const rawCookie = useCookie('blackroll_loyalty');

  // Only store the boolean loyalty status in state (safe to cache)
  // Email should be read fresh from cookie when needed to avoid cache issues
  useState('is-loyalty-user', () => !!rawCookie.value);
});
